
import { RevPopover, RevTooltip } from '@backmarket/design-system'

import translations from '../../OutOfStock.translations'

export default {
  components: {
    RevPopover,
    RevTooltip,
  },
  props: {
    price: {
      type: String,
      required: true,
    },
    reference: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    translations: () => translations,
  },
}
